import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: 12,
      maxWidth: 500,
      width: '100%',
      overflow: 'hidden',
      boxShadow: '0 24px 64px rgba(0,0,0,0.4)',
    },
    '& .MuiBackdrop-root': {
      backgroundColor: 'transparent',
    },
  },
  modal: {
    padding: '48px 44px',
    textAlign: 'center',
    fontFamily: ({ fontFamily }) => fontFamily || 'Arial, sans-serif',
  },
  title: {
    fontSize: '1.75rem',
    fontWeight: 700,
    lineHeight: 1.3,
    marginBottom: 14,
    color: ({ primaryColor }) => primaryColor || '#233154',
    fontFamily: 'inherit',
  },
  description: {
    fontSize: '1.1rem',
    lineHeight: 1.6,
    color: '#555',
    marginBottom: 36,
    fontFamily: 'inherit',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  btnYes: {
    display: 'block',
    width: '100%',
    padding: '11px 20px',
    fontSize: '0.95rem',
    fontWeight: 600,
    letterSpacing: '0.01em',
    borderRadius: 8,
    textTransform: 'none',
    backgroundColor: ({ primaryColor }) => primaryColor || '#233154',
    color: '#fff',
    boxShadow: 'none',
    '&:hover': {
      opacity: 0.88,
      backgroundColor: ({ primaryColor }) => primaryColor || '#233154',
      boxShadow: 'none',
    },
  },
  btnNo: {
    display: 'block',
    width: '100%',
    padding: '11px 20px',
    fontSize: '0.95rem',
    fontWeight: 600,
    letterSpacing: '0.01em',
    borderRadius: 8,
    textTransform: 'none',
    backgroundColor: 'transparent',
    color: ({ secondaryColor }) => secondaryColor || '#0763A0',
    borderColor: ({ secondaryColor }) => secondaryColor || '#0763A0',
    '&:hover': {
      opacity: 0.88,
      backgroundColor: 'transparent',
    },
  },
  blockWrap: {
    position: 'relative',
    overflow: 'hidden',
    padding: '48px 44px',
    textAlign: 'center',
    fontFamily: ({ fontFamily }) => fontFamily || 'Arial, sans-serif',
  },
  blockBg: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    color: ({ secondaryColor }) => secondaryColor || '#0763A0',
    opacity: 0.06,
  },
  blockContent: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
  },
  blockTitle: {
    fontSize: '1.4rem',
    fontWeight: 700,
    lineHeight: 1.3,
    color: ({ primaryColor }) => primaryColor || '#233154',
    fontFamily: 'inherit',
    margin: 0,
  },
  blockMsg: {
    fontSize: '1.05rem',
    lineHeight: 1.6,
    color: ({ secondaryColor }) => secondaryColor || '#0763A0',
    fontFamily: 'inherit',
    margin: 0,
    maxWidth: 320,
  },
}))

export default useStyles
